import React from 'react'
import {StyledComponent} from 'powtoon-components/types'
import './ProgressCircle.scss'


export interface ProgressCircleType extends StyledComponent {
  radius: number,
  stroke: number,
  progress: number,
  progressColor?: string,
  backgroundColor?: string,
  textColor?: string,
  progressSecondaryColor?: string,
  withPercentage?: boolean,
  textClass?: string
}

const ProgressCircle: React.FC<ProgressCircleType> = ({
  radius, stroke, progress, progressColor = 'black', backgroundColor = 'transparent', textColor = 'black',
  progressSecondaryColor = 'grey', withPercentage, textClass = ''
}) => {

  const svg = React.useMemo(() => {
    const circumference = radius * 2 * Math.PI
    const strokeDashoffset = circumference - progress / 100 * circumference
    const realRadius = radius + stroke
    const realDiameter = realRadius * 2
    return {circumference, strokeDashoffset, realRadius, realDiameter}
  }, [radius, progress, stroke])


  return (
    <div styleName="progress-circle">
      <svg
        height={svg.realDiameter}
        width={svg.realDiameter}
      >
        <circle
          stroke={progressSecondaryColor}
          fill={backgroundColor}
          strokeWidth={stroke}
          r={radius}
          cx={svg.realRadius}
          cy={svg.realRadius}
        />
        <circle
          stroke={progressColor}
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={`${svg.circumference  } ${  svg.circumference}`}
          style={{strokeDashoffset: svg.strokeDashoffset}}
          r={radius}
          cx={svg.realRadius}
          cy={svg.realRadius}
        />
        {withPercentage && (
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            stroke={textColor}
            fill={textColor}
            styleName="percentage"
            className={textClass}
          >
            {`${progress}%`}
          </text>
        )}
      </svg>
    </div>
  )
}

export default ProgressCircle
